import { FC, RefObject } from "react";
import { ExpandedState } from "@tanstack/react-table";
import { type DataGridHandle, ExpandAllButton } from "@design-system/DataGrid";
import {
    getWorkBoardGroupBy,
    WORK_BOARD_GROUP_BY_OPTIONS,
} from "./board/workBoardColumns";
import { GroupBySelect } from "./GroupBySelect";
import { GROUP_BY_OPTIONS, GroupBy } from "./useGroupedTableData";

interface WorkGroupingControlsProps {
    isBoardLayout: boolean;
    groupBy: GroupBy;
    onGroupByChange: (groupBy: GroupBy | null) => void;
    expanded: ExpandedState;
    tableRef: RefObject<DataGridHandle | null>;
}

/** The Work page header's grouping picker, plus List's collapse-all button when it's grouped. */
export const WorkGroupingControls: FC<WorkGroupingControlsProps> = ({
    isBoardLayout,
    groupBy,
    onGroupByChange,
    expanded,
    tableRef,
}) => (
    <>
        {!isBoardLayout && groupBy !== "none" && (
            <ExpandAllButton expanded={expanded} handleRef={tableRef} />
        )}
        <GroupBySelect
            value={isBoardLayout ? getWorkBoardGroupBy(groupBy) : groupBy}
            onValueChange={onGroupByChange}
            options={
                isBoardLayout ? WORK_BOARD_GROUP_BY_OPTIONS : GROUP_BY_OPTIONS
            }
        />
    </>
);
